import * as RadixScrollArea from '@radix-ui/react-scroll-area'
import {ReactNode} from 'react'
import {ScrollAreaProps as RadixScrollAreaProps, ScrollAreaViewportProps} from '@radix-ui/react-scroll-area'
import {Scrollbar} from '@components/ui/scrollbar/Scrollbar.tsx'
import * as React from 'react'

type ScrollAreaProps = {
    children: ReactNode
    scrollbar: ReturnType<typeof Scrollbar>
    viewportProps?: ScrollAreaViewportProps & React.RefAttributes<HTMLDivElement>
} & RadixScrollAreaProps

export const ScrollArea = React.forwardRef<HTMLDivElement, ScrollAreaProps>(
    ({children, scrollbar, viewportProps, ...rest}, ref) => (
        <RadixScrollArea.Root scrollHideDelay={500} {...rest}>
            <RadixScrollArea.Viewport style={{height: '100%'}} {...viewportProps} ref={ref}>
                {children}
            </RadixScrollArea.Viewport>
            {scrollbar}
        </RadixScrollArea.Root>
    )
)
